import { StaticProvider } from '@angular/core';
import { SOFTLINE_CONFIG_INDEXED_DB } from '@softline/core';
import { SOFTLINE_INDEXED_DB_USER } from './user.indexed-db';


export const userProviders: StaticProvider[] = [
  { provide: SOFTLINE_CONFIG_INDEXED_DB, useValue: SOFTLINE_INDEXED_DB_USER, multi: true },
]
